import { User } from "lucide-react";
import FacebookShare from "./FacebookShare";

export default function PotgCard({ game }) {
    const p = game.player_of_the_game;
    if (!p) return null;
    const team = game.home_team?.id === p.team_id ? game.home_team : game.away_team;
    const cutout = p.epic_photo;
    return (
        <div
            data-testid={`potg-card-${game.id}`}
            className="relative mt-5 rounded-2xl overflow-hidden border border-[#FFB800]/40 bg-[#0C0C13]"
        >
            {(cutout || p.photo_url) && (
                <img
                    src={cutout || p.photo_url}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
                />
            )}
            <div className="absolute inset-0 bg-gradient-to-r from-[#08080C] via-[#08080C]/75 to-transparent" />
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#FFB800] to-transparent" />
            <div
                aria-hidden="true"
                className="absolute -left-6 top-1/2 -translate-y-1/2 w-40 h-40 rounded-full bg-[#FFB800]/15 blur-3xl"
            />
            <div className="relative flex items-center gap-4 sm:gap-5 p-4 sm:p-5">
                {cutout ? (
                    <img
                        src={cutout}
                        alt={p.name}
                        data-testid={`potg-photo-${game.id}`}
                        className="h-24 sm:h-28 w-auto object-contain animate-float-slow"
                        style={{ filter: "drop-shadow(0 0 25px rgba(255,184,0,0.5))" }}
                    />
                ) : p.photo_url ? (
                    <img
                        src={p.photo_url}
                        alt={p.name}
                        data-testid={`potg-photo-${game.id}`}
                        className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl object-cover object-top border-2 border-[#FFB800]/60 shadow-[0_0_30px_rgba(255,184,0,0.35)]"
                    />
                ) : (
                    <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-[#1A1A28] border-2 border-[#FFB800]/60 flex items-center justify-center">
                        <User className="w-8 h-8 text-slate-500" />
                    </div>
                )}
                <div className="min-w-0">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-[#FFB800]">
                        Player of the Game
                    </p>
                    <p className="font-display font-black uppercase text-2xl sm:text-3xl text-white leading-none mt-1 truncate">
                        <span className="font-stat text-[#FF5500] text-xl mr-2">#{p.number}</span>
                        {p.name}
                    </p>
                    <p className="text-xs text-slate-400 mt-1.5">
                        {p.position} • {team?.name}
                    </p>
                    {game.potg_statline && (
                        <p className="font-stat text-sm text-[#FFB800] mt-1.5">{game.potg_statline}</p>
                    )}
                </div>
                <FacebookShare
                    path={`/share/game/${game.id}`}
                    target={`potg-card-${game.id}`}
                    fileName={`ykpbl-potg-${game.id}.png`}
                    testid={`share-potg-${game.id}`}
                    className="ml-auto self-start shrink-0"
                />
            </div>
        </div>
    );
}
